import { SET_SITE_UPDATES, SET_SITE_UPDATE_COUNTS } from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const setUpdateCounts = (count) => {
        return {
            type: SET_SITE_UPDATE_COUNTS,
            payload: count,
        };
    };

    const fetchUpdateCounts = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`meta/updates`);
                dispatch(setUpdateCounts(response.data.data));
            } catch (err) {
                console.error(err);
            }
        };
    };

    const setUpdates = (updates) => {
        return {
            type: SET_SITE_UPDATES,
            payload: updates,
        };
    };

    const fetchUpdates = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`meta/updates/list`);
                dispatch(setUpdates(response.data.data));
            } catch (err) {
                console.error(err);
            }
        };
    };

    return {
        fetchUpdateCounts,
        fetchUpdates,
    };
};

export default initActions;
